import React, { useState, useEffect, useRef } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AuthData } from "../../auth/AuthWrapper"
import { FileCode,CircleChevronLeft,FileText, LayoutGrid, ClipboardList, File, Settings, Menu,FileCheck, FileClock,UserCheck,User, CircleChevronRight, Plus} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getUsername,getInitials } from "../../utils/common_functions";
import { apiCall } from "../../utils/server_utils";
import Message from "../common/message";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import JsonFormBuilder from "./infrastructurecontext.js"
import { useParams,useNavigate } from "react-router-dom";
import { MoreVertical, Eye, Download, Share2, Star, Trash, FilePen,LayoutPanelTop} from "lucide-react";
import Sidebar from '../structure/sidebar'; 

export default function DeleteConfirmationDialog({ isOpen, onClose, onConfirm,templateName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-296">
        <h2 className="text-xl font-semibold mb-4">Delete</h2>
        <p className="text-gray-600 mb-6">Are you sure you want to delete {templateName} item?</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-gray-600 text-white hover:bg-gray-700 transition"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}


// 🧩 Reusable NavItem component with hover tooltip
const NavItem = ({ to, icon, label, isSidebarOpen }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `group relative flex items-center p-2 rounded hover:bg-gray-700 transition-all duration-200 ${
        isSidebarOpen ? "justify-start" : "justify-center"
      } ${isActive ? "bg-white text-black font-medium" : "text-white"}`
    }
  >
    {icon}
    {isSidebarOpen ? (
      <span className="ml-2">{label}</span>
    ) : (
      <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-lg">
        {label}
      </span>
    )}
  </NavLink>
);


export const InfrastructureContext = () => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
      // Initialize from localStorage, default to false
      const saved = localStorage.getItem('isSidebarOpen');
      return saved === 'true';
    });
  
    // Update localStorage whenever isSidebarOpen changes
    useEffect(() => {
      localStorage.setItem('isSidebarOpen', isSidebarOpen);
    }, [isSidebarOpen]);

  const { user, isLoggedIn, logout } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // API data for documents
  const [cloudService, setCloudService] = useState([]); // API data for documents
  const dropdownRef = useRef(null);
  let {documentid,documentname,type} = useParams(); // Extract the `id` parameter from the URL
  const [openDropdown, setOpenDropdown] = useState(null);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedJosn,setselectedJosn] = useState(null);
  const navigate = useNavigate();
  const handleDelete = async () => {

    try {

                const result = await apiCall("POST", `${API_SERVER_URL}templates/`+selectedJosn._id+`/delete/`);
                if(result!==undefined){
                  if (result.code === API_SUCCESS_RESPONSE_CODE) {
                    setIsDialogOpen(false)
                    setselectedJosn(null)
                    fetchWidget()
                    if (targetElement) {
                      ReactDOM.unmountComponentAtNode(targetElement);
                    }
                    ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
                  }
                 
                }
            } catch (error) {
              console.error("Error refreshing token:", error);
            }

  };



  //alert(documentid);


  const gotoTemplate = () => {
    navigate("/infrastructure-context")
  };

  const backtolist = () => {
    setselectedJosn(null)
    fetchWidget();
    navigate("/infrastructure-context/list")
  };



  const fetchCloudSerivces = async () => {
  try {
    const result = await apiCall("GET", `${API_SERVER_URL}templates/cloud-services/`);
    if (result.code === API_SUCCESS_RESPONSE_CODE) {
      setCloudService(result.data)
    }
  } catch (error) {
    setLoading(false);  
    console.error("Error fetching contracts", error);
  }
  }

  const fetchWidget = async () => {
    setLoading(true); // Stop loading spinner
  try {
    const result = await apiCall("GET", `${API_SERVER_URL}templates/`);
    if (result.code === API_SUCCESS_RESPONSE_CODE) {

    //   let samplejson = {
    //     "success": true,
    //     "data": [
    //         {
    //             "_id": "6822267deb5b055f3a1a9eec",
    //             "templateName": "Test template - savad2",
    //             "cloud": "AWS",
    //             "deploymentArchitecture": "cloud",
    //             "compliance": "Gxp",
    //             "defaultScope": "Both",
    //             "defaultEnvironment": "QA",
    //             "architectureSummary": "",
    //             "assumptions": [],
    //             "outOfScope": [],
    //             "feedback": [],
    //             "user": {
    //                 "id": "ec14a8ed-77c5-4110-8fb9-e88214482c48",
    //                 "name": "Savad"
    //             },
    //             "created": [
    //                 "2025-05-12 22:19:01"
    //             ]
    //         }
    //     ],
    //     "error": null,
    //     "code": 200
    // }
    //   setData(samplejson.data);
     setData(result.data);
      setLoading(false);  
    }
  } catch (error) {
    setLoading(false);  
    console.error("Error fetching contracts", error);
  }
};

  useEffect(() => {
      // Fetch data from the API
   
      fetchWidget();
      fetchCloudSerivces();
    }, []);

      useEffect(() => {
        function handleClickOutside(event) {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOpenDropdown(null);  // Close dropdown if click is outside
          }
        }
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [dropdownRef]);
    

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar logout={logout} isSidebarOpen={isSidebarOpen} />
      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-24'}`}>

      <button
  className="absolute ml-[-10px] top-4  flex items-center justify-center rounded-full text-white bg-blue-500 hover:bg-blue-600 z-50"
  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
>
  {isSidebarOpen ? (
    <CircleChevronLeft className="w-5 h-5" />
  ) : (
    <CircleChevronRight className="w-5 h-5" />
  )}
</button>
 <header className="flex items-center justify-between p-4 bg-white shadow md:pl-6">
    
 
    <button
       className="md:hidden p-2 rounded text-gray-700 hover:bg-gray-200 -ml-5"
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    >
      <Menu className="w-6 h-6" size={16} />
      </button>

    {/* Flex container for title and buttons */}
    <div className="flex flex-col w-full md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-2xl font-bold">Configure Infrastructure Context</h1>
        <p className="text-gray-600">Manage and track configure infrastructure context</p>
      </div>
      <div className="flex gap-3 mt-4 md:mt-0">
        
      {type==="list" && (<button
  id="btn_uplod"
  onClick={gotoTemplate}
  className="mr-12 group relative flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
>
  <Plus className="h-4 w-4" />

  {/* Tooltip BELOW the button */}
  <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-md">
  Add Infrastructure Context
  </span>
</button>)}




{/* 
        <button id="btn_uplod" onClick={gotoTemplate} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-600">
          <LayoutPanelTop className="mr-2 h-4 w-4" /> Configure Template
        </button> */}

      </div>
    </div>
  </header>

        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">
          {/* Overview Cards */}
                   {loading ? (
                           <PageLoader />
                      ) :
          
          

          <>


          {type==="list" ?

<>

{  selectedJosn!==null && isDialogOpen === false ?
<>
<div className="flex justify-between items-center border-b p-3  text-sm">
       {/* Left section */}
       <div className="flex items-center space-x-4">
         <div className="flex items-center space-x-1 text-blue-600 cursor-pointer" onClick={backtolist}>
           <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
             <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7 7-7" />
           </svg>
           <span className="font-medium">Back to Infrastructure Contexts</span>
         </div>
       </div>
     </div>  
  <JsonFormBuilder
  documentid={selectedJosn._id}
  documentname={selectedJosn.templateName}
  editJson = {(selectedJosn)}
  cloudService= {cloudService}
  backtolist={backtolist}
  type={type}
  />
  
  </>
:
<>

<div className="flex items-center justify-between mb-4">
                  <div className="flex gap-2 flex-wrap">
                        &nbsp;
                  </div>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="border border-gray-300 rounded px-3 py-1.5 text-sm"
                    />
                  </div>
                </div>

                {console.log(data)}
            {/* Document List */}
                  <div className="space-y-4">
    {
                        data.length === 0 && (<div class="text-center text-gray-600 text-lg mt-4">
                        No Infrastructure Context Found
                      </div>)
    }
                  {data!==undefined ? 
                    data.map((doc, index) => (
                      <div
                        key={doc._id}
                        className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 flex justify-between items-start"
                      >
                        {/* Left: Icon + Info */}
                        <div className="flex gap-3 items-start">
                        
                        <div className="flex-shrink-0 p-2 rounded-lg bg-slate-50">
                        <div  className={`text-3xl ${doc.iconColor}`}><FileText className="h-10 w-10 text-indigo-600" /></div>
                        </div>
            
                          <div>
                            {/* <a   className="text-blue-600 hover:underline cursor-pointer"
              onClick={() => handleViewRequirements(doc.document_id)}><h2 
             className="text-md font-semibold">{doc.title}</h2></a> */}
            
            
                            <h2 className="text-md font-semibold">{doc.templateName}</h2>
            
            
                            <div className="text-sm text-gray-500 flex gap-2 mt-1">
                              <span>{doc.created}</span> · <span>{doc.user.name}</span>
                            </div>
                             <div className="flex gap-2 mt-2 flex-wrap">
                      
                      <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-gray-200 text-gray-800">
                      Cloud Provider :  {doc.cloud}
                      </span>
                      <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-gray-200 text-gray-800">
                      Compliance :  {doc.compliance}
                      </span>
                      <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-gray-200 text-gray-800">
                      Default Environment :  {doc.defaultEnvironment}
                      </span>
                      
             {/*
            
                      <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-green-200 text-gray-800">
                      Approved :  {doc.approved_count}
                      </span>
            
                      <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-blue-200 text-gray-800">
                      Un Approved :  {doc.unapproved_count}
                      </span> */}
                            </div>
                          </div>
            
                        </div>


                        
                                    {/* Right: Actions */}
                                    <div className="relative" ref={dropdownRef}>
                                    <div className="flex gap-2">
                                      <button onClick={() => setOpenDropdown(openDropdown === doc._id ? null : doc._id)}>
                                        <MoreVertical className="text-gray-500 hover:text-black" />
                                      </button>
                                      </div>

                                         {openDropdown === doc._id && (
                                                      <div onMouseDown={(e) => e.stopPropagation()} className="absolute right-0 mt-2 w-148 bg-white border border-gray-200 rounded shadow z-50">
                                                        <div className="p-2 font-medium text-sm border-b">Actions</div>
                                                        
                                                        <button onClick={() => {setselectedJosn(doc);setOpenDropdown(null);}}  className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-grey-600 text-sm w-full">
                                                          <FilePen className="w-4 h-4" /> Edit
                                                        </button>
                                                        

                                                        <button onClick={() => {setselectedJosn(doc);setIsDialogOpen(true);setOpenDropdown(null);}} className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-grey-600 text-sm w-full">
                                                          <Trash className="w-4 h-4" /> Delete
                                                        </button>
                                                      </div>
                                                    )}
                                      
                                      
            
                     </div>
                     </div>  
                     
                    )) : data.length === 0 && (<div class="text-center text-gray-600 text-lg mt-4">
                    No Infrastructure Context
                  </div>)
                  }
                  </div>

<DeleteConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => {setIsDialogOpen(false);setselectedJosn(null)}}
        onConfirm={handleDelete}
        templateName={selectedJosn!==null ? selectedJosn.templateName : "this"}
      />
</>

      }


         
            </>
             :
             <>
             <div className="flex justify-between items-center border-b p-3  text-sm">
  {/* Left section */}
  <div className="flex items-center space-x-4">
    <div className="flex items-center space-x-1 text-blue-600 cursor-pointer" onClick={backtolist}>
      <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7 7-7" />
      </svg>
      <span className="font-medium">Back to Infrastructure Context List</span>
    </div>
  </div>

</div>

             <JsonFormBuilder
            documentid={documentid}
            documentname={documentname}
            type={type}
            backtolist={backtolist}
            cloudService= {cloudService}
            />
            </>
          }
          </> 
          
          }
        </main>
      </div>
    </div>
  );
};